import { useNavigate } from "react-router-dom";
import { formatSocialMentions } from "../../utils/data";
import useAgentData from "../../utils/hooks/useAgentData";
import FilterButton from "../shared/FilterButton";

const SocialMediaMentions = () => {
  const { socialMentions, loading } = useAgentData();
  const navigate = useNavigate();

  if (loading || !socialMentions) return null;

  const SocialMediaMentionsItems = formatSocialMentions(socialMentions);

  return (
    <div className="w-full flex-col bg-white shadow-[4px_4px_47.1px_0px_#00000040] rounded-[12px] flex items-start pb-4 pt-2 gap-2">
      <div className="w-full border-b pb-2 pl-3 border-[#0000002B] flex flex-row items-center justify-between">
        <span className="w-full text-[13px] font-semibold font-inter leading-[100%] text-black">
          Social Media Mentions
        </span>
        <FilterButton onClick={() => console.log("Filter clicked")} />
      </div>

      {SocialMediaMentionsItems.map((item, index) => (
        <div
          key={index}
          onClick={() => navigate("/social-media")}
          className="flex flex-col items-start w-full gap-3 px-3 pt-2 cursor-pointer"
        >
          <div className="flex flex-row items-start w-full gap-3">
            <div
              className={`w-[26px] h-[26px] ${item.bgColor} rounded-full flex items-center justify-center`}
            >
              <img
                src={item.icon}
                alt="icon"
                className="w-[15px] h-[15px] object-contain"
              />
            </div>

            <div className="flex flex-col w-full">
              <div className="flex items-center justify-between w-full">
                <span className="text-[13px] font-semibold font-inter leading-[100%] text-black">
                  {item.username}
                </span>
                <span className="text-[11px] font-medium font-inter leading-[100%] text-[#00000073] px-2 py-0.5 rounded">
                  {item.timestamp}
                </span>
              </div>
              <div className="text-[11px] py-1 font-inter text-[#00000073] text-opacity-80">
                {item.message}
              </div>
              <div className="flex flex-row gap-x-2">
                <div className="flex flex-row items-center">
                  <img
                    src="/icons/reply.png"
                    alt="reply"
                    className="w-[15px] h-[15px] object-contain"
                  />
                  <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
                    Reply
                  </span>
                </div>
                <div className="flex flex-row items-center">
                  <img
                    src="/icons/like.png"
                    alt="like"
                    className="w-[12px] h-[12px] object-contain"
                  />
                  <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
                    Like
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SocialMediaMentions;
